<template>
  <div>
    <new-maker-dialog v-model="isNewMakerDialogOpened" @created="makerCreated" />
    <new-users-dialog v-model="isNewUsersDialogOpened" :maker="newMaker" @ended="usersCreated" />
    <new-priorities-dialog v-model="isNewPrioritiesDialogOpened" :maker="newMaker" @ended="prioritiesCreated" />
    <new-domains-dialog v-model="isNewDomainsDialogOpened" :maker="newMaker" @ended="domainsCreated" />
    <template v-if="isSelfMakerUser && isSelfIntervention === null">
      <v-row no-gutters justify="center" align="center" class="pa-10 ma-12">
        <v-col>
          <n-card clickable class="mr-2 pa-6 text-center" @click="isSelfIntervention = false">
            <div class="pb-2">
              <v-icon>construction</v-icon>
            </div>
            <div class="font-weight-bold">
              Faire appel à un<br />
              prestataire extérieur
            </div>
          </n-card>
        </v-col>
        <div class="px-7">OU</div>
        <v-col>
          <n-card clickable class="ml-2 pa-6 text-center" @click="setClientAsMaker">
            <div class="pb-2">
              <v-icon>home</v-icon>
            </div>
            <div class="font-weight-bold">
              Réaliser la prestation<br />
              en interne
            </div>
          </n-card>
        </v-col>
      </v-row>
    </template>
    <n-card v-else>
      <template v-if="!isFetchingMakers">
        <v-card-text>
          <v-row no-gutters justify="center" align="center">
            <v-col style="max-width: 300px;" v-if="false"></v-col>
            <v-col>
              <v-row no-gutters justify="center" align="center">
                <div>
                  <v-row no-gutters justify="center" align="center" class="border-component mr-3" style="height: 40px;">
                    <v-autocomplete
                      :items="tags"
                      v-model="searchTags"
                      single-line
                      solo
                      label="Tous les tags"
                      hide-details
                      item-text="label"
                      item-value="id"
                      no-data-text="Aucun tag"
                      clearable
                      dense
                      flat
                      multiple
                      chips
                      deletable-chips
                      small-chips
                      style="width: 100%;"
                      class="n-multi-select input-no-b-line"
                    >
                      <template v-slot:item="{ item: tag }">
                        <v-list-item-avatar size="20" style="margin-top: 4px;">
                          <v-avatar :color="tag.color"></v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          {{ tag.label }}
                        </v-list-item-content>
                      </template>
                    </v-autocomplete>
                  </v-row>
                </div>
                <v-col>
                  <v-text-field
                    v-model="searchString"
                    placeholder="Rechercher un prestataire..."
                    prepend-inner-icon="search"
                    hide-details
                    dense
                    clearable
                    outlined
                  ></v-text-field>
                </v-col>
                <v-btn dark color="primary" elevation="0" class="ml-4" @click="isNewMakerDialogOpened = true" v-if="canAddMaker">
                  <v-icon left>add</v-icon>
                  Nouveau
                </v-btn>
              </v-row>
              <v-row no-gutters justify="center" align="center" class="pt-10 pb-6" v-if="!filteredMakers.length">
                Aucun résultat
              </v-row>
              <template v-else>
                <div class="pt-4 pb-2">
                  <v-row no-gutters justify="center" align="center">
                    <h3 class="pl-2">{{ filteredMakers.length }} {{ `prestataire` | pluralize(filteredMakers.length) }} {{ `trouvé` | pluralize(filteredMakers.length) }}</h3>
                    <v-spacer />
                    <div>
                      <v-row no-gutters justify="center" align="center">
                        <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                          <v-icon>chevron_left</v-icon>
                        </v-btn>
                        <div class="ml-2 primary--text font-weight-bold">
                          {{ currentPage + 1 }} / {{ nbPages }}
                        </div>
                        <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                          <v-icon>chevron_right</v-icon>
                        </v-btn>
                      </v-row>
                    </div>
                  </v-row>
                </div>
                <n-card depressed v-for="maker in filteredMakersPaginated" :key="maker.id" @click="chooseMaker(maker)" class="my-4 clickable chosse-maker-card">
                  <v-row no-gutters justify="center" align="center">
                    <v-col class="py-2 px-4">
                      <div class="font-weight-bold">{{ maker.name }}</div>
                      <div v-if="maker.address">{{ maker.address }}</div>
                      <div>
                        <span class="pr-2" v-if="maker.postalCode">{{ maker.postalCode }}</span>
                        <span v-if="maker.city">{{ maker.city }}</span>
                      </div>
                      <div v-if="maker.$domains.length">
                        Domaine{{ maker.$domains.length > 1 ? `s` : `` }} : {{ maker.$domains.join(`, `) }}
                      </div>
                      <div v-if="maker.$clientTags.length">
                        <tag-chip v-for="tag in maker.$clientTags" :key="`tag-${tag.id}`" :tag="tag" />
                      </div>
                    </v-col>
                    <v-divider vertical />
                    <div class="py-2 px-4">
                      <v-icon>chevron_right</v-icon>
                    </div>
                  </v-row>
                </n-card>
                <div class="pa-4">
                  <v-row no-gutters justify="center" align="center">
                    <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                      <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <div class="ml-2 primary--text font-weight-bold">
                      {{ currentPage + 1 }} / {{ nbPages }}
                    </div>
                    <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                      <v-icon>chevron_right</v-icon>
                    </v-btn>
                  </v-row>
                </div>
              </template>
            </v-col>
          </v-row>
          <template v-if="false">
            <div v-if="isSelectingMultipleMakers">
              <v-alert type="info" outlined text>
                Sélectionnez les prestataires que vous souhaitez mettre en concurrence
              </v-alert>
              <form class="mt-2" @submit.prevent.stop="submit()">
                <v-autocomplete
                  :error="autocompleteError"
                  multiple
                  chips
                  label="Prestataires à mettre en concurrence *"
                  :items="flavoredMakers"
                  v-model="selectedMakerIds"
                  item-value="id"
                  item-text="name"
                  hide-details
                  :clearable="!autocompleteReadonly"
                  outlined
                  :success="autocompleteSuccess"
                  :readonly="autocompleteReadonly"
                  :loading="autocompleteLoading"
                  :no-data-text="autocompleteNoDataText"
                />
              </form>
              <v-row no-gutters justify="end" align="center" class="mt-3">
                <v-btn v-if="isChallengingIntervention" color="primary darken-1" depressed @click="submit">Suivant</v-btn>
              </v-row>
            </div>
            <form @submit.prevent.stop="submit()" v-else>
              <v-autocomplete
                :error="autocompleteError"
                label="Chez quel prestataire ouvrir cette intervention ? *"
                :items="flavoredMakers"
                v-model="selectedMakerId"
                item-value="id"
                item-text="name"
                hide-details
                :clearable="!autocompleteReadonly"
                outlined
                :success="autocompleteSuccess"
                :readonly="autocompleteReadonly"
                :loading="autocompleteLoading"
                :no-data-text="autocompleteNoDataText"
                :disabled="isChallengingIntervention"
                :background-color="isChallengingIntervention ? `grey lighten-2` : ``"
                append-icon=""
                @change="submit()"
              />

              <v-row no-gutters justify="center" align="center" class="mt-3" v-if="isAggregator && false">
                <v-switch label="Mettre en concurrence plusieurs prestataires" v-model="isChallengingIntervention"></v-switch>
                <v-spacer></v-spacer>
                <v-btn v-if="isChallengingIntervention" color="primary darken-1" depressed @click="isSelectingMultipleMakers = true">Suivant</v-btn>
              </v-row>

              <input type="submit" value="" style="display: none;">
            </form>
          </template>

        </v-card-text>

        <v-divider></v-divider>

      </template>
      <template v-else>
        <v-row no-gutters justify="center" align="center" class="my-5">
          <v-progress-circular indeterminate color="primary darken-1"></v-progress-circular>
        </v-row>
      </template>
    </n-card>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters, mapState } from 'vuex';
import NewMakerDialog from '@/components/Settings/Makers/NewMakerDialog.vue';
import NewUsersDialog from '@/components/Settings/Makers/NewUsersDialog.vue';
import NewPrioritiesDialog from '@/components/Settings/Makers/NewPrioritiesDialog.vue';
import NewDomainsDialog from '@/components/Settings/Makers/NewDomainsDialog.vue';

const PAGE_SIZE = 25;

export default {
  data: () => ({
    searchString: ``,
    searchTags: [],
    isChallengingIntervention: false,
    isSelectingMultipleMakers: false,
    selectedMakerId: null,
    selectedMakerIds: [],
    isSelfIntervention: null,
    isSubmiting: false,
    isFetchingMakers: false,
    autocompleteError: false,
    autocompleteSuccess: false,
    autocompleteReadonly: false,
    isNewMakerDialogOpened: false,
    isNewUsersDialogOpened: false,
    isNewPrioritiesDialogOpened: false,
    isNewDomainsDialogOpened: false,
    newMaker: null,
    currentPage: 0,
  }),
  computed: {
    ...mapState(`ui/newIntervention`, [
      `tags`,
    ]),
    ...mapState(`model/client`, [
      `company`,
      `isMaker`,
      `isAggregator`,
    ]),
    ...mapState(`model/user`, [
      `me`,
      `isMakerUser`,
      `isSelfMakerUser`,
    ]),
    ...mapGetters(`model/maker`, {
      makers: `writeMakers`,
    }),
    ...mapState(`model/client`, [
      `isAggregator`,
    ]),
    flavoredMakers() {
      return _.chain(this.makers)
        .orderBy(`name`)
        .filter(maker => maker.id !== this.company.id)
        .map(maker => ({
          ...maker,
          $domains: _.chain(maker.domains || [])
            .map(`name`)
            .sortBy(domain => _.toLower(domain))
            .value(),
        }))
        .map(maker => ({
          ...maker,
          searchString: _.toLower(`
            ${maker.name} ${maker.address || ``} ${maker.postalCode || ``} ${maker.city || ``} ${maker.$domains.join(` `)}
          `),
          $clientTags: _.sortBy(maker.clientTags || [], tag => _.toLower(tag.label)),
          $clientTagsIds: _.map(maker.clientTags || [], `id`),
        }))
        .value();
    },
    filteredMakers() {
      let makers = this.flavoredMakers;
      if (_.trim(this.searchString) !== ``) {
        const searchString = _.lowerCase(this.searchString);
        makers = _.filter(makers, maker =>
          maker.searchString.indexOf(searchString) !== -1
        );
      }
      if (this.searchTags.length) {
        makers = _.filter(makers, maker =>
          _.without(this.searchTags, ...maker.$clientTagsIds).length === 0
        );
      }
      return makers;
    },
    filteredMakersPaginated() {
      const firstIndex = this.currentPage * PAGE_SIZE;
      return this.filteredMakers.slice(firstIndex, firstIndex + PAGE_SIZE);
    },
    nbPages() {
      return Math.ceil(this.filteredMakers.length / PAGE_SIZE);
    },
    canAddMaker() {
      return this.me && !this.company.isRoot && (this.me.clientAdmin || this.me.isIndego);
    },
  },
  methods: {
    async fetchmakers() {
      this.isFetchingMakers = true;
      if (this.isAggregator) {
        await this.$store.dispatch(`model/maker/fetchMakersForClient`, this.company.id);
      } else {
        await this.$store.dispatch(`model/maker/fetchMakers`);
      }
      this.isFetchingMakers = false;
      this.$emit(`ready`);
      if (this.isMaker) {
        const maker = _.find(this.makers, { id: this.company.id });
        this.chooseMaker(maker);
      } else if (this.isMakerUser) {
        const maker = _.find(this.makers, { id: this.me.Client_id });
        this.chooseMaker(maker);
      }
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      const newPageIndex = (this.currentPage + 1) * PAGE_SIZE;
      if (newPageIndex < this.filteredMakers.length) {
        this.currentPage += 1;
      }
    },
    chooseMaker(maker) {
      this.selectedMakerId = maker.id;
      return this.submit();
    },
    submit() {
      if (this.isSubmiting) { return; }
      this.isSubmiting = true;
      this.autocompleteError = false;
      this.autocompleteReadonly = false;
      this.autocompleteSuccess = false;
      if (
        (this.isChallengingIntervention && !this.selectedMakerIds.length)
        || (!this.isChallengingIntervention && !this.selectedMakerId)
      ) {
        setTimeout(() => { this.autocompleteError = true; });
        this.isSubmiting = false;
        return;
      }
      this.autocompleteReadonly = true;
      this.autocompleteSuccess = true;
      let makers = [];
      if (this.isSelfIntervention) {
        makers = [this.company];
      } else if (this.isChallengingIntervention) {
        makers = _.filter(this.makers, maker => this.selectedMakerIds.includes(maker.id));
      } else {
        makers = [_.find(this.makers, { id: this.selectedMakerId })];
      }
      this.$store.commit(`ui/newIntervention/SET_MAKERS`, makers);
      // const maker = _.find(this.makers, { id: this.selectedMakerIds });
      this.$emit(`choose`, makers);
    },
    setClientAsMaker() {
      this.isSelfIntervention = true;
      this.selectedMakerId = this.company.id;
      this.submit();
    },
    makerCreated(maker) {
      this.newMaker = maker;
      this.isNewUsersDialogOpened = true;
      this.fetchmakers();
    },
    usersCreated() {
      this.isNewUsersDialogOpened = false;
      this.isNewPrioritiesDialogOpened = true;
    },
    prioritiesCreated() {
      this.isNewPrioritiesDialogOpened = false;
      this.isNewDomainsDialogOpened = true;
    },
    domainsCreated() {
      this.isNewDomainsDialogOpened = false;
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Création du prestaire terminée`,
      });
      const maker = _.find(this.flavoredMakers, { id: this.newMaker.id });
      this.chooseMaker(maker);
      this.newMaker = null;
    },
  },
  watch: {
    searchString() {
      this.currentPage = 0;
    },
    searchTags() {
      this.currentPage = 0;
    },
  },
  beforeMount() {
    this.fetchmakers();
  },
  components: {
    NewMakerDialog,
    NewUsersDialog,
    NewPrioritiesDialog,
    NewDomainsDialog,
  },
};
</script>
